import * as AgcOpSwagger from './swagger/agcOp/types';
export { AgcOpSwagger };
export var AgcOpFbEmailVerifyStatus;
(function (AgcOpFbEmailVerifyStatus) {
    AgcOpFbEmailVerifyStatus[AgcOpFbEmailVerifyStatus["Wait"] = -1] = "Wait";
    AgcOpFbEmailVerifyStatus[AgcOpFbEmailVerifyStatus["Valid"] = 1] = "Valid";
    AgcOpFbEmailVerifyStatus[AgcOpFbEmailVerifyStatus["ValidUnknown"] = 2] = "ValidUnknown";
    AgcOpFbEmailVerifyStatus[AgcOpFbEmailVerifyStatus["Invalid"] = 0] = "Invalid";
    AgcOpFbEmailVerifyStatus[AgcOpFbEmailVerifyStatus["InvalidDomain"] = 3] = "InvalidDomain";
})(AgcOpFbEmailVerifyStatus || (AgcOpFbEmailVerifyStatus = {}));
export var AgcOpFbPhoneFormatStatus;
(function (AgcOpFbPhoneFormatStatus) {
    AgcOpFbPhoneFormatStatus[AgcOpFbPhoneFormatStatus["Wait"] = 0] = "Wait";
    AgcOpFbPhoneFormatStatus[AgcOpFbPhoneFormatStatus["Valid"] = 1] = "Valid";
    AgcOpFbPhoneFormatStatus[AgcOpFbPhoneFormatStatus["Invalid"] = 2] = "Invalid";
})(AgcOpFbPhoneFormatStatus || (AgcOpFbPhoneFormatStatus = {}));
export var AgcOpFbPhoneVerifyStatus;
(function (AgcOpFbPhoneVerifyStatus) {
    AgcOpFbPhoneVerifyStatus[AgcOpFbPhoneVerifyStatus["Wait"] = 0] = "Wait";
    AgcOpFbPhoneVerifyStatus[AgcOpFbPhoneVerifyStatus["Valid"] = 1] = "Valid";
    AgcOpFbPhoneVerifyStatus[AgcOpFbPhoneVerifyStatus["Invalid"] = 2] = "Invalid";
})(AgcOpFbPhoneVerifyStatus || (AgcOpFbPhoneVerifyStatus = {}));
export var AgcOpFbLeadsUserMarkStatus;
(function (AgcOpFbLeadsUserMarkStatus) {
    AgcOpFbLeadsUserMarkStatus[AgcOpFbLeadsUserMarkStatus["Wait"] = 0] = "Wait";
    AgcOpFbLeadsUserMarkStatus[AgcOpFbLeadsUserMarkStatus["Valid"] = 1] = "Valid";
    AgcOpFbLeadsUserMarkStatus[AgcOpFbLeadsUserMarkStatus["Invalid"] = 2] = "Invalid";
})(AgcOpFbLeadsUserMarkStatus || (AgcOpFbLeadsUserMarkStatus = {}));
